import _objectSpread from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent, ref, reactive, toRefs, watch, inject, createVNode, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { Modal, Checkbox, message } from 'ant-design-vue';
import { _home, _user } from '@/api';
import { dealRouterMenus, localStorageClear } from '@/util';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import Cookies from 'js-cookie';
import i18n from '@/locale';
import iconMenuNeutral from '@/assets/icons/icon-menu-neutral.svg';
export default defineComponent({
  setup: function setup() {
    var store = useStore();
    var router = useRouter();
    var route = useRoute();
    var editRef = ref(null);
    var collapsed = ref(false);
    var validPasswordFormat = function validPasswordFormat(rule, value) {
      var pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/;
      if (!value) return Promise.reject(i18n.global.t(rule.field === 'newPassword' ? 'pages_user_058' : 'pages_user_059') + i18n.global.t('common_text_042'));
      if (!pattern.test(value)) return Promise.reject(i18n.global.t('pages_user_060'));
      if (rule.field === 'secPassword' && value !== state.editForm.newPassword) return Promise.reject(i18n.global.t('pages_user_061'));
      return Promise.resolve();
    };
    var state = reactive({
      themeData: inject('$themeData'),
      userInfo: {},
      loading: false,
      visible: false,
      agreementList: [],
      openKeys: ["/".concat(route.path.split('/')[1])],
      selectedKeys: [route.path],
      model: null,
      menus: dealRouterMenus(store.getters.menuList),
      editForm: {
        oldPassword: '',
        newPassword: '',
        secPassword: ''
      },
      editRules: {
        oldPassword: [{
          required: true
        }],
        newPassword: [{
          required: true,
          validator: validPasswordFormat
        }],
        secPassword: [{
          required: true,
          validator: validPasswordFormat
        }]
      }
    });
    var frontProVersion = computed(function () {
      return store.state.map.frontProVersion;
    });
    watch(function () {
      return router.currentRoute.value;
    }, function (route) {
      if (!collapsed.value) {
        state.openKeys = ["/".concat(route.path.split('/')[1])];
        state.selectedKeys = [route.path];
      }
      if (!store.getters.statusAll) store.dispatch('getLanguage');
    }, {
      immediate: true
    });
    var toggleCollapsed = function toggleCollapsed() {
      collapsed.value = !collapsed.value;
    };
    var menuLink = function menuLink(_ref) {
      var key = _ref.key;
      init();
      store.dispatch('getCurList');
      router.push(key || '/error404');
    };
    var signAgree = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _home.updateAgreement();
            case 1:
              res = _context.v;
              if (!res.data.succ) {
                _context.n = 3;
                break;
              }
              state.userInfo.agreeStatus = '00';
              _context.n = 2;
              return store.commit('updateUserInfo', state.userInfo);
            case 2:
              init();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function signAgree() {
        return _ref2.apply(this, arguments);
      };
    }();
    var updateCancel = function updateCancel() {
      state.visible = false;
      localStorage.setItem('updatePassword', true);
    };
    var passwordUpdate = function passwordUpdate() {
      editRef.value.validateFields().then(function () {
        state.loading = true;
        var _state$editForm = state.editForm,
          oldPassword = _state$editForm.oldPassword,
          newPassword = _state$editForm.newPassword;
        return _user.modifyPassword({
          oldPassword: oldPassword,
          newPassword: newPassword
        });
      }).then(function (res) {
        state.loading = false;
        if (res.data.succ) {
          message.success(i18n.global.t('common_text_022'));
          localStorageClear();
          router.replace('/login');
        } else {
          message.error(res.data.resMsg);
        }
      })["catch"](function (err) {
        return console.log(err);
      });
    };
    var showAgreeModal = function showAgreeModal() {
      var createVNodes = [createVNode('span', {}, i18n.global.t('pages_main_031'))];
      if (process.env.VUE_APP_SAASNAME !== 'MAIN') {
        state.agreementList.map(function (item) {
          createVNodes.push(createVNode('a', {
            href: "#/agreement/".concat(item.agreementKey),
            target: '_blank'
          }, "\u300A".concat(item.agreementName, "\u300B")));
        });
      } else {
        createVNodes.push(createVNode('a', {
          href: '#/terms_service',
          target: '_blank'
        }, i18n.global.t('pages_main_032')));
        createVNodes.push(createVNode('a', {
          href: '#/privacy_policy',
          target: '_blank'
        }, i18n.global.t('pages_main_033')));
      }
      state.modal = Modal.confirm({
        title: i18n.global.t('pages_main_029'),
        icon: createVNode(ExclamationCircleOutlined),
        width: 500,
        okButtonProps: {
          disabled: true
        },
        content: createVNode('div', {}, [createVNode('div', {}, i18n.global.t('pages_main_030')), createVNode(Checkbox, {
          style: {
            marginTop: '24px'
          },
          onChange: function onChange(e) {
            return state.modal.update({
              okButtonProps: {
                disabled: !e.target.checked
              }
            });
          }
        }, function () {
          return createVNodes;
        })]),
        onOk: function onOk() {
          return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return signAgree();
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }))();
        },
        onCancel: function onCancel() {
          router.replace('/home/index');
        }
      });
    };
    var loadMerchantInfo = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, merchantNo, status, _res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _home.getMerchantInfo();
            case 1:
              res = _context3.v;
              if (!res.data.succ) {
                _context3.n = 7;
                break;
              }
              // check if data valid, has a valid merchatNo
              merchantNo = res.data.data.merchantNo; // non-empty string check
              if (!(!merchantNo || typeof merchantNo !== 'string' || merchantNo.trim() === '')) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              status = res.data.data.status;
              if (!(status === 'CUSTOMER')) {
                _context3.n = 3;
                break;
              }
              state.modal = Modal.confirm({
                title: i18n.global.t('pages_main_056', [i18n.global.locale.value === 'zh' ? state.themeData.saasMerNameZh : state.themeData.saasMerNameEn]),
                icon: createVNode(ExclamationCircleOutlined),
                width: 540,
                okText: i18n.global.t('pages_main_036'),
                onOk: function onOk() {
                  router.push('/guide_page');
                },
                onCancel: function onCancel() {
                  router.replace('/home/index');
                }
              });
              _context3.n = 7;
              break;
            case 3:
              if (!(status === 'CUSTREJ')) {
                _context3.n = 4;
                break;
              }
              state.modal = Modal.confirm({
                title: i18n.global.t('pages_main_037'),
                icon: createVNode(ExclamationCircleOutlined, {
                  style: {
                    color: '#ff4d4f'
                  }
                }),
                width: 500,
                okText: i18n.global.t('pages_main_038'),
                onOk: function onOk() {
                  router.push('/merchant_info');
                },
                onCancel: function onCancel() {
                  router.replace('/home/index');
                }
              });
              _context3.n = 7;
              break;
            case 4:
              if (!(status !== 'OPENFINSH')) {
                _context3.n = 5;
                break;
              }
              state.modal = Modal.info({
                title: i18n.global.t('pages_main_039'),
                icon: createVNode(ExclamationCircleOutlined),
                width: 500,
                content: createVNode('div', {
                  style: {
                    marginTop: '24px'
                  }
                }, i18n.global.t('pages_main_040')),
                onOk: function onOk() {
                  router.replace('/home/index');
                }
              });
              _context3.n = 7;
              break;
            case 5:
              state.visible = state.userInfo.first && !localStorage.getItem('updatePassword');
              if (state.visible) {
                _context3.n = 7;
                break;
              }
              _context3.n = 6;
              return _user.checkReportFile();
            case 6:
              _res = _context3.v;
              if (_res.data.succ && _res.data.data.check) {
                state.modal = Modal.warning({
                  title: _res.data.data.msg,
                  icon: createVNode(ExclamationCircleOutlined),
                  width: 500
                });
              }
            case 7:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function loadMerchantInfo() {
        return _ref3.apply(this, arguments);
      };
    }();
    var loadSaasMerAgreement = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _user.getSaasMerAgreement({});
            case 1:
              res = _context4.v;
              if (res.data.succ) state.agreementList = res.data.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function loadSaasMerAgreement() {
        return _ref4.apply(this, arguments);
      };
    }();
    var init = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (state.menus.length === 0) {
                Cookies.remove('last_page_name');
                localStorageClear();
                router.replace('/login');
              }
              if (!(process.env.VUE_APP_SAASNAME !== 'MAIN')) {
                _context5.n = 1;
                break;
              }
              _context5.n = 1;
              return loadSaasMerAgreement();
            case 1:
              state.userInfo = store.getters.getUserInfo;
              if (state.userInfo.agreeStatus === '01') showAgreeModal();else if (state.userInfo.agreeStatus === '02') signAgree();else loadMerchantInfo();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return function init() {
        return _ref5.apply(this, arguments);
      };
    }();
    init();
    return _objectSpread({
      editRef: editRef,
      menuLink: menuLink,
      updateCancel: updateCancel,
      passwordUpdate: passwordUpdate,
      toggleCollapsed: toggleCollapsed,
      collapsed: collapsed,
      iconMenuNeutral: iconMenuNeutral,
      frontProVersion: frontProVersion
    }, toRefs(state));
  }
});